import { ContentPlacement } from '@candu-ai/placement/types';
import { TooltipPosition } from 'craft/resolvers/Hotspot/types';

type TooltipPositionStyle = number | string;

type PositionalStyles = {
  top?: TooltipPositionStyle;
  left?: TooltipPositionStyle;
  bottom?: TooltipPositionStyle;
  right?: TooltipPositionStyle;
};

const TOOLTIP_STYLES: Record<TooltipPosition, PositionalStyles> = {
  bottom: {
    top: '0',
    left: '50%',
  },
  top: {
    bottom: '20px',
    left: '50%',
  },
  left: {
    top: '50%',
    right: '50px',
  },
  right: {
    top: '50%',
    left: '20px',
  },
  auto: {
    top: '50%',
    left: '20px',
  },
};

const TOOLTIP_WRAPPER_STYLES: Record<TooltipPosition, PositionalStyles> = {
  bottom: {
    top: 50,
  },
  top: {
    top: undefined,
    bottom: 50,
  },
  left: {
    left: undefined,
    right: 70,
  },
  right: {
    left: 70,
  },
  auto: {
    left: 70,
  },
};

export const getTooltipMountPosition = (
  placement: ContentPlacement,
  tooltipPosition: TooltipPosition,
): PositionalStyles => {
  return TOOLTIP_STYLES[tooltipPosition];
};

export const getOverrideTooltipWrapperStyles = (
  tooltipPosition: TooltipPosition,
): PositionalStyles => {
  return TOOLTIP_WRAPPER_STYLES[tooltipPosition];
};
